<template>
    <q-card>
        <q-form @submit.prevent="updateProperties">
            <q-card-section>
                <div class="text-h6">Дополнительные поля</div>
            </q-card-section>

            <q-card-section>
                <q-btn @click="addProperty" label="Добавить" color="primary"/>
            </q-card-section>
            <q-card-section v-for="(property) in properties" class="q-gutter-md">
                <q-input dense v-model.trim="property.label" label="Имя" :rules="[requiredRule]" :hint="`Доступ в отчетности: ${property.code}`"/>
                <q-select v-model="property.type" :options="propertyOptions"
                          label="Тип" emit-value behavior="menu"
                          map-options/>
                <template v-if="property.type ==='STRING' ">
                    <q-input v-model="property.value" label="Значение" :rules="[requiredRule]"/>
                </template>
                <template v-if="property.type ==='NUMBER' ">
                    <q-input v-model.number="property.value"  label="Значение" type="number" :rules="[requiredRule]"/>
                </template>
                <template v-if="property.type ==='DATE'">
                    <q-input v-model="property.value"  label="Значение" :rules="[requiredRule]">
                        <template v-slot:prepend>
                            <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-date v-model="property.value" mask="YYYY-MM-DD">
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat/>
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                </template>
                <template v-if="property.type ==='DATETIME'">
                    <q-input v-model="property.value"  label="Значение" :rules="[requiredRule]">
                        <template v-slot:prepend>
                            <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-date v-model="property.value" mask="YYYY-MM-DD HH:mm">
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat/>
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>

                        <template v-slot:append>
                            <q-icon name="access_time" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-time v-model="property.value" mask="YYYY-MM-DD HH:mm" format24h>
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat/>
                                        </div>
                                    </q-time>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                </template>
                <q-btn @click="removeProperty(property)" label="Удалить" color="negative"/>
            </q-card-section>

            <q-card-actions align="right" class="text-primary">
                <q-btn no-caps flat label="Обновить" type="submit"/>
            </q-card-actions>
        </q-form>
    </q-card>
</template>

<script setup lang="ts">
import {requiredRule} from "../util/rules";
import {propertyOptions} from "../util/property";
import cyrillicToTranslit from "cyrillic-to-translit-js";
import {useRouteParams} from "@vueuse/router";
import {useProjectProperties, useUpdateProjectProperties} from "../composables/project";
import {reactive, ref, watch} from "vue";
import {ProjectProperty} from "../models/project";
import {useQuasar} from "quasar";

const $q = useQuasar()
const translit = cyrillicToTranslit()
const projectId = useRouteParams('projectId', undefined, {transform: Number})
const properties = ref<ProjectProperty[]>([])
const {data, execute: refresh} = useProjectProperties(projectId.value);

watch(data, (val) => {
    if (val) {
        properties.value = val
    }
})
const {execute} = useUpdateProjectProperties(projectId.value, properties);


function addProperty() {
    const property = reactive<ProjectProperty>({
        label: "",
        code: "",
        type: "STRING",
        value: ""
    });
    watch(() => property.label, (val: string) => {
        property.code = translit.transform(val, "_").toLowerCase()
    })
    properties.value = properties.value.concat([property])
}

async function updateProperties() {
    await execute(true)
    await refresh()
    $q.dialog({
        title: "Обновление",
        message: "Поля были обновлены"
    })
}
function removeProperty(property: ProjectProperty) {
    const oldProperties = properties.value
    const index = oldProperties.indexOf(property);
    if (index !== -1) {
        oldProperties.splice(index, 1);
    }
    properties.value = oldProperties
}
</script>

<style scoped>

</style>